import { BaseEntityDto } from '../common/base-entity.dto';
import {
  VerificationTaskType,
  VerificationTaskPriority,
  VerificationTaskStatus
} from '../../enums';

export interface VerificationTaskDto extends BaseEntityDto {
  taskType: VerificationTaskType;
  title: string;
  description: string;
  entityId: string; // Guid
  entityType: string;
  entityName: string;
  priority: VerificationTaskPriority;
  status: VerificationTaskStatus;
  dueDate: string; // DateTime as ISO string
  assignedToUserId?: string | null; // Guid
  assignedToUserName?: string | null;
  actionUrl?: string | null;
  metadata?: Record<string, unknown>; // Additional context data
}
